import React from "react";
import { translate } from "../../translate";
import { STRINGS } from "../../strings";
import { AppAbstractModal } from "../Generic/AppModal/AppAbstractModal";
import { AppButton } from "../Generic/AppButton";
import styled from "@emotion/styled";
import { Center } from "../Center";
import LocationSearch from "../../../public/assets/lotties/Location-Search.json";
import Lottie from "react-lottie";

interface Props {
  isOpen: boolean;
  address: string;
  milesFromCaregivers: number;
  onClickConfirm: () => void;
  onClickClose: () => void;
}

const lottieOptions = {
  loop: true,
  autoplay: true,
  animationData: LocationSearch,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const FarVisitWarningModal = (props: Props) => {
  return (
    <ModalWrapper isOpen={props.isOpen} onRequestClose={props.onClickClose}>
      <Header>
        <Lottie options={lottieOptions}></Lottie>
        <div>{translate(STRINGS.FAR_VISIT_WARNING_MODAL_TITLE)}</div>
      </Header>
      <p>
        {translate(STRINGS.VISIT_IS_NEAR_ADDRESS_X_MILES_FROM_YOU)
          .replace("{ADDRESS}", props.address)
          .replace("{MILES}", props.milesFromCaregivers.toString())}
        <br />
        <br />
        {translate(STRINGS.ARE_YOU_SURE_REQUEST_FAR_VISIT)}
      </p>
      <Center>
        <ActionsWrapper>
          <ActionButton color="primary" onClick={() => props.onClickConfirm()}>
            {translate(STRINGS.YES_REQUEST_ANYWAY)}
          </ActionButton>
          <ActionButton variant="link" textColor="black" onClick={() => props.onClickClose()}>
            {translate(STRINGS.I_HAVE_CHANGED_MY_MIND)}
          </ActionButton>
        </ActionsWrapper>
      </Center>
    </ModalWrapper>
  );
};

export default FarVisitWarningModal;

const ModalWrapper = styled(AppAbstractModal)`
  .container {
    padding: 24px;
    background-color: white;
    border-radius: 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    max-height: 90vh;
    overflow-y: auto;
  }
`;
const Header = styled.div`
  text-align: center;
  font-size: 25px;
  font-weight: 600;
`;

const ActionsWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
`;

const ActionButton = styled(AppButton)`
  width: 250px;
`;
